export enum AskSupportTrigger {
  ERROR = 'error',
  TIMEOUT = 'timeout',
  IMMEDIATE = 'immediate'
}

export interface AskSupportData {
  concern: string;
  trigger: AskSupportTrigger;
  payload?: any;
  supportQuery?: SupportQuery;
}

export type SupportQuery = string | ((error: string) => string);
